module.exports = __webpack_public_path__ + "static/media/ils-report-Generated.b0ba3f81.svg";